module.exports = __webpack_public_path__ + "523ca5f9c5c3c8771cac680fc9c6e484.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_another_team.png
// module id = 10
// module chunks = 0 1 2 3 4